// @flow

import styled, { css } from 'styled-components';

import colors from '../config/colors';

const SectionHeader = styled.div`
  margin-top: 2em;
  h3 {
    margin-bottom: 0;
  }
  h3 + h4 {
    margin-top: 0;
  }
`;

const Section = styled.section`
  padding: 2em;
  position: relative;

  h1, h2, h3, h4, h5, h6 {
    text-align: center;
  }

  h2 {
    font-size: 18px;
  }

  h4 {
    font-size: 11px;
    font-weight: 300;
    letter-spacing: 2px;
    text-transform: uppercase;
  }

  ${props => props.primary && css`
    background-color: ${props => props.theme.sectionBg1};
    background-image: linear-gradient(to bottom, ${props => props.theme.sectionBg1}, ${props => props.theme.sectionBg2});
    color: white;
    padding: 2em 2em 3em;
    text-align: center;

    h1, h2 {
      color: white;
    }

    h1 {
      font-size: 22px;
    }

    h2 {
      font-size: 18px;
      font-weight: 300;
    }

    @media (min-width: 375px) {
      h1 {
        font-size: 26px;
      }
      h2 {
        font-size: 20px;
      }
    }
  `}

  ${props => props.light && css`
    color: ${colors.text.light};
  `}

  > :first-child {
    margin-top: 0;
  }

  > p:last-child {
    margin-bottom: 0;
  }

  .instructions {
    text-align: center;
    @media (min-width: 375px) {
      padding: 0 1em;
    }
  }

  .limit-width {
    margin-left: auto;
    margin-right: auto;
    max-width: ${props => props.theme.maxWidth};
  }
`;

const GradientSection = styled(Section)`
  background-color: ${props => props.bg1 || props.theme.lightBg1};
  background-image: linear-gradient(to bottom, ${props => props.bg1 || props.theme.lightBg1}, ${props => props.bg2 || props.theme.lightBg2});
`;

export default Section;
export { GradientSection, SectionHeader };



// WEBPACK FOOTER //
// ./src/components/Section.js